// Date and formatting utilities
export function toDate(value) {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function toTimestamp(value) {
  const date = toDate(value);
  return date ? date.getTime() : 0;
}

export function formatDialogTime(value) {
  const date = toDate(value);
  if (!date) return "";

  const now = new Date();
  const isSameYear = date.getFullYear() === now.getFullYear();
  const isSameMonth = isSameYear && date.getMonth() === now.getMonth();
  const isSameDay = isSameMonth && date.getDate() === now.getDate();

  if (isSameDay) {
    return new Intl.DateTimeFormat("ru-RU", { hour: "2-digit", minute: "2-digit" }).format(date);
  }

  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  const isYesterday =
    date.getFullYear() === yesterday.getFullYear() &&
    date.getMonth() === yesterday.getMonth() &&
    date.getDate() === yesterday.getDate();

  if (isYesterday) return "Вчера";

  return new Intl.DateTimeFormat("ru-RU", {
    day: "2-digit",
    month: isSameYear ? "short" : "2-digit",
    year: isSameYear ? undefined : "2-digit",
  }).format(date);
}

export function formatMessageTime(value) {
  const date = toDate(value);
  if (!date) return "";
  return new Intl.DateTimeFormat("ru-RU", { hour: "2-digit", minute: "2-digit" }).format(date);
}

export function formatDateSeparator(value) {
  const date = toDate(value);
  if (!date) return "";

  const now = new Date();
  const isToday =
    date.getFullYear() === now.getFullYear() &&
    date.getMonth() === now.getMonth() &&
    date.getDate() === now.getDate();

  if (isToday) return "Сегодня";

  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  const isYesterday =
    date.getFullYear() === yesterday.getFullYear() &&
    date.getMonth() === yesterday.getMonth() &&
    date.getDate() === yesterday.getDate();

  if (isYesterday) return "Вчера";

  return new Intl.DateTimeFormat("ru-RU", {
    day: "numeric",
    month: "long",
  }).format(date);
}

export function formatDateKey(value) {
  const date = toDate(value);
  if (!date) return "0";
  return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
}

export function initials(name) {
  const prepared = String(name || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2);

  if (!prepared.length) return "—";
  return prepared.map((part) => part[0]).join("").toUpperCase();
}

export function bytesLabel(bytes) {
  const n = Number(bytes);
  if (!Number.isFinite(n) || n <= 0) return "";
  if (n < 1024) return `${n} Б`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} КБ`;
  return `${(n / (1024 * 1024)).toFixed(1)} МБ`;
}

export function buildTypingText({ activeDialog, activeTypingUsers }) {
  const ids = Array.isArray(activeTypingUsers) ? activeTypingUsers : [];
  if (!ids.length && !activeDialog?.typing) return "";

  const members = Array.isArray(activeDialog?.members) ? activeDialog.members : [];
  if (!ids.length) return "Печатает...";

  const names = ids
    .map((id) => {
      const member = members.find((item) => Number(item?.userId ?? item?.id) === Number(id));
      return member?.name || member?.fullName || member?.title || null;
    })
    .filter(Boolean);

  if (!names.length) return "Печатает...";
  if (names.length === 1) return `${names[0]} печатает...`;
  if (names.length === 2) return `${names[0]} и ${names[1]} печатают...`;
  return `${names[0]} и еще ${names.length - 1} печатают...`;
}
